import { defineStyle } from '@chakra-ui/react';

import 'swiper/css';
import 'swiper/swiper-bundle.css';

const style = defineStyle({
  root: {
    w: '100%',
    h: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
});
export default style;
